import { Injectable, Type } from '@angular/core';
import { EmailStepConfigComponent } from '../../../components/workflow-step-config/email-step-config/email-step-config.component';
import { ConditionStepConfigComponent } from '../../../components/workflow-step-config/condition-step-config/condition-step-config.component';
import { DelayStepConfigComponent } from '../../../components/workflow-step-config/delay-step-config/delay-step-config.component';
import { SmsStepConfigComponent } from '../../../components/workflow-step-config/sms-step-config/sms-step-config.component';
import { LandingPageEventStepConfigComponent } from '../../../components/workflow-step-config/landing-page-event-step-config/landing-page-event-step-config.component';
import { ChangeDataEventStepConfigComponent } from '../../../components/workflow-step-config/change-data-event-step-config/change-data-event-step-config.component';
import { EmailEventStepConfigComponent } from '../../../components/workflow-step-config/email-event-step-config/email-event-step-config.component';
import { SaveQueryStepConfigComponent } from '../../../components/workflow-step-config/save-query-step-config/save-query-step-config.component';
import { AbstractStepDTO } from '@tj/tj-dmp-lib-api';

@Injectable({
  providedIn: 'root'
})
export class StepConfigRegistryService {

  private componentRegistry = new Map<string, Type<any>>([
    ['EMAIL', EmailStepConfigComponent],
    ['CONDITION_IF', ConditionStepConfigComponent],
    ['DELAY', DelayStepConfigComponent],
    ['SMS', SmsStepConfigComponent],
    ['LANDING_PAGE_EVENT', LandingPageEventStepConfigComponent],
    ['CHANGE_DATA_EVENT', ChangeDataEventStepConfigComponent],
    ['EMAIL_EVENT', EmailEventStepConfigComponent],
    [AbstractStepDTO.TypeEnum.SAVEQUERY, SaveQueryStepConfigComponent]
  ]);

  getComponentForStep(stepType: string): Type<any> | null {
     return this.componentRegistry.get(stepType) || null;
  }

  registerComponent(stepType: string, component: Type<any>): void {
    this.componentRegistry.set(stepType, component);
  }
}
